export default {
    orders: {
        actionUndo: {
            message: "If you clicked in error, click the link below to revert.",
            undo: "Click to Undo"
        }
    }
}